import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NotesComponent } from '../components/notes/notes.component';
import { NoteItemComponent } from '../components/notes/widgets/note-item/note-item.component';
import { AddNoteComponent } from '../components/notes/widgets/add-note/add-note.component';
import { NoteEditorComponent } from '../components/notes/widgets/note-editor/note-editor.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NameAvatarComponent } from '../components/notes/widgets/note-avatar/note-avatar.component';
import { NzInputModule } from 'ng-zorro-antd/input';
@NgModule({
  declarations: [
    NotesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NoteItemComponent,
    NzButtonModule,
    NameAvatarComponent,
    NzInputModule,
    AddNoteComponent,
    NoteEditorComponent
  ],
  exports: [NotesComponent, AddNoteComponent, NoteEditorComponent]
})
export class NotesModule { }
